"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _OS2EY4T5cjs = require('../__chunks/OS2EY4T5.cjs');


var _XXF5DFSGcjs = require('../__chunks/XXF5DFSG.cjs');
require('../__chunks/5OZ7J4C2.cjs');
require('../__chunks/NKGUWTUC.cjs');
require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/O7FALLU5.cjs');
require('../__chunks/MLKK6UGO.cjs');
require('../__chunks/WU47XUXM.cjs');
require('../__chunks/OJZKTJL7.cjs');
require('../__chunks/MMSR5JSJ.cjs');
require('../__chunks/EV33XSIB.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function MenuProvider(props = {}) {
  const store = _OS2EY4T5cjs.useMenuStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _XXF5DFSGcjs.MenuContextProvider, { value: store, children: props.children });
}


exports.MenuProvider = MenuProvider;
